CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
List = require 'models/list'
Util = require 'lib/util'

module.exports = class ListList extends CollectionWithHelpers
  model: List
  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort
    @board = options.board
    return

  comparator: (list) -> list.get('pos') || 0

  calcPos: (index, list, includeList) ->
    Util.calcPos(index, @, list, null, includeList)

  url: ->
    "/1/boards/#{ @board.id }/lists"



// WEBPACK FOOTER //
// ./app/scripts/models/collections/list-list.coffee